/*
 * @Date: 2020-03-11 15:12:35
 * @LastEditors: chentianyang
 * @LastEditTime: 2021-09-09 20:33:52
 * @FilePath: \st-teacher-2020\src\views\index\main.ts
 */
import Vue from 'vue';
import indexPlugin from '@/plugins/indexPlugin';
import {
  Modal, Icon, Input, Radio, Button, Tree, Tooltip, message, Tabs,
} from 'ant-design-vue';
import App from './App.vue';
import router from './router';
import store from '../../store';
import '@/assets/style/common.sass';

Vue.config.productionTip = false;
Vue.prototype.$message = message;
// 所有初始化操作都在这里
Vue.use(indexPlugin);
Vue.use(Modal); // fixed vue warn: Failed to resolve directive: ant-portal
Vue.use(Icon);
Vue.use(Input);
Vue.use(Radio);
Vue.use(Button);
Vue.use(Tree);
Vue.use(Tooltip);
Vue.use(Tabs);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
